import { LocalStorage } from 'src/services/LocalStorage';
import { useRequestFormStore } from 'src/features/requests/request-form/use-request-form-store';

// Every entry point that opens the request-form modal for a genuinely new
// session (create or edit) must clear the shared 'formValues' localStorage
// slot and set the session's currentRequestId together, or a stale draft
// left by an unrelated prior session can seed this one's initial values
// (#2565). Centralized here after independently hand-rolled copies of these
// two lines at each call site meant one was missed (the WebView launch
// path) and reintroduced the bug it was meant to prevent.
export const clearRequestFormDraft = (requestId?: string) => {
  LocalStorage.set('formValues', null);
  useRequestFormStore.getState().setCurrentRequestId(requestId);
};

// Shared by every "auto-launch a brand-new create-request session" entry
// point (WebView launch, mobile deep-link) that calls the store's openModal
// directly rather than going through useOpenRequestModal. Kept as one
// function so a future change to the launch contract can't be applied to
// one entry point and missed on another, the same way the WebView path
// originally missed the clearRequestFormDraft call above.
export const openFreshCreateRequestSession = () => {
  clearRequestFormDraft(undefined);
  useRequestFormStore.getState().openModal({
    isMultiStep: true,
    currentStep: 2,
  });
};
